import RequestBuilder from 'Resources/RequestBuilder';
import AppService from 'App/legacy/AppService';
import { MultiSelectContext } from 'App/components/MultiselectProvider/MultiselectProvider';
import MultiActions from 'Resources/MultiActions';

const restoreTickets = (
	rb: RequestBuilder,
	entity: string,
	multiSelectContext: MultiSelectContext,
	extraParams?: object
) => {
	const properties = [{ name: 'isArchived', value: false }];
	const customerId = AppService.getCustomerId();
	return MultiActions.customer(customerId).updateTicket(multiSelectContext.selected, properties, rb.build());
};

export default restoreTickets;
